import WidgetVisualization from './WidgetVisualization';

export default WidgetVisualization;
